import { Appointment, AppointmentID } from "./Appointment";
import { Car, CarID } from "./Car";
import { Customer, CustomerID } from "./Customer";
import { COMMUNICATION_CHANNELS, SMS_GATEWAYS, TwilioMessageSID } from "./CustomerCommunication";
import { COMMUNICATION_RECEIVER_STATUSES } from "./CustomerCommunicationEvent";
import { DealerLocationID } from "./DealerLocation";
import { User, UserID } from "./User";

export type AcsesCommunicationID = number;

export type AcsesCommunicationEventID = number;

export type AcsesCommunicationReceiverID = number;

export enum ACSES_COMMUNICATION_EVENT_TYPES {
  DropBackPinSent = 1
}

export interface AcsesCommunication {
  created_on: string;
  updated_on: string;
  id: AcsesCommunicationID;
  customer_id: CustomerID | null; // Customer who this AcsesCommunication is for
  appointment_id: AppointmentID; // Appointment from which this AcsesCommunication originated from
  car_id: CarID; // Car from which the Appointment is for
  dealer_location_id: DealerLocationID; // DealerLocation from which the Appointment is from
  receptionist_id: UserID; // Identifier of the user
  receptionist?: User; // Embedded Receptionist of the ReceptionistID
  customer?: Customer; // Embedded Customer of the CustomerID
  appointment?: Appointment; // Embedded Appointment of the AppointmentID
  car?: Car; // Embedded Car of the CarID
  events?: AcsesCommunicationEvent[]; // Embedded all Events created for this communication
}

export interface AcsesCommunicationEvent {
  created_on: string;
  updated_on: string;
  id: AcsesCommunicationEventID;
  user_id: UserID; // Identifier of the user
  type: ACSES_COMMUNICATION_EVENT_TYPES; // Type of AcsesCommunicationEvent
  acses_communication_id: AcsesCommunicationID; // Identifier of the Acses Communication
  user?: User; // Embedded User of the UserID
  receivers?: AcsesCommunicationReceiver[]; // Embedded all Receivers created for this event
  appointment_id: AppointmentID; // Used for websocket event lookup
}

export interface AcsesCommunicationReceiver {
  created_on: string;
  updated_on: string;
  id: AcsesCommunicationReceiverID;
  acses_communication_event_id: AcsesCommunicationEventID; // Acses Communication Event Identifier
  communication_channel_id: COMMUNICATION_CHANNELS; // Type of communication channel used
  destination: string; // Recipient identifier for the channel used
  status: COMMUNICATION_RECEIVER_STATUSES; // Status of the communication receiver
  reason: string; // Reason in case of any failure
  sms_gateway_id: SMS_GATEWAYS | null; // Type of gateway used in case of SMS
  twilio_message_sid: TwilioMessageSID | null; // Identifier of the SMS in Twilio
  mailgun_message_id: string; // Mailgun message identifier for identifying the email
  appointment_id: AppointmentID;
}
